"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _react = _interopRequireWildcard(require("react"));
var _label = _interopRequireDefault(require("@ingka/label"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
class RadioButton extends _react.Component {
  constructor(props) {
    super(props);
    if (_react.createRef) {
      this.radiobutton = (0, _react.createRef)();
    }
  }
  render() {
    const {
      className,
      prefix,
      id,
      label,
      name,
      value,
      onChange,
      disabled,
      describedById,
      required,
      subtle,
      ...other
    } = this.props;
    const classes = (0, _classnames.default)(className, `${prefix}radio`, subtle && `${prefix}radio--subtle`);
    return _react.default.createElement("span", {
      className: classes
    }, _react.default.createElement("input", _extends({
      type: "radio",
      value: value,
      name: name,
      id: id,
      ref: el => this.radiobutton = el,
      disabled: disabled,
      onChange: disabled ? null : onChange,
      "aria-describedby": describedById,
      required: required
    }, other)), _react.default.createElement("span", {
      className: `${prefix}radio__symbol`
    }), label && _react.default.createElement("span", {
      className: `${prefix}radio__label`
    }, _react.default.createElement(_label.default, {
      prefix: prefix,
      htmlFor: id,
      label: label
    })));
  }
}
RadioButton.defaultProps = {
  prefix: '',
  name: 'radioname',
  disabled: false,
  subtle: false
};
var _default = RadioButton;
exports.default = _default;